import axios from "axios";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import Spinner from "../Layout/Spinner";
import "./css/OrganizationDetails.scss";

function OrganizationDetails() {
  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo(0, 0);
  }, []);
  const { user } = useSelector((state) => state.user);

  const [loading, setLoading] = useState(false);
  const [responseData, setResponseData] = useState({
    color: "",
    message: "",
  });

  const [organizationDetails, setOrganizationDetails] = useState({
    name: "",
    description: "",
    link: {
      url: "",
      linkType: "",
    },
  });
  const [submitMessage, setSubmitMessage] = useState({
    color: "",
    message: "",
  });
  const [initialMessage, setInitialMessage] = useState({
    color: "",
    message: "",
  });
  const [hasFetchedData, setHasFetchedData] = useState(false);

  const handleInputChange = (e) => {
    setOrganizationDetails({
      ...organizationDetails,
      [e.target.name]: e.target.value,
    });
  };

  const handleRadioChange = (e) => {
    setOrganizationDetails({
      ...organizationDetails,
      link: {
        ...organizationDetails.link,
        [e.target.name]: e.target.value,
      },
    });
  };

  const validateForm = () => {
    if (!organizationDetails.name.trim()) {
      return { isValid: false, message: "Organization name is required" };
    }
    if (!organizationDetails.description.trim()) {
      return {
        isValid: false,
        message: "Organization description is required",
      };
    }
    if (!organizationDetails.link.url.trim()) {
      return { isValid: false, message: "Website URL is required" };
    }
    return { isValid: true, message: "" };
  };

  // const submit = async (event) => {
  //     event.preventDefault();
  //     setLoading(true);

  //     try {
  //         const { data } = await axios.put(`/api/employer/addOrgDetails/${user._id}`, organizationDetails);

  //         setResponseData({ color: "blue", message: data.message });
  //     } catch (error) {
  //         console.log("Error :- ", error);
  //         setResponseData({ color: "red", message: error.response.data.message });
  //     } finally {
  //         setLoading(false);
  //     }
  // }

  const submit = async (event) => {
    event.preventDefault();

    // Validate form before submission
    const validation = validateForm();
    if (!validation.isValid) {
      setSubmitMessage({ color: "red", message: validation.message });
      return;
    }

    setLoading(true);

    try {
      const { data } = await axios.put(
        `/api/employer/addOrgDetails/${user._id}`,
        organizationDetails
      );
      setSubmitMessage({
        color: "green",
        message: data.message || "Organization details saved successfully!",
      });

      // Clear the initial message after successful submission
      setInitialMessage({ color: "", message: "" });
    } catch (error) {
      console.log("Error :- ", error);
      setSubmitMessage({
        color: "red",
        message:
          error.response?.data?.message ||
          "An error occurred while saving details",
      });
    } finally {
      setLoading(false);
    }
  };

  // useEffect(() => {
  //     async function getOrgDetails() {
  //         const { data } = await axios.get(`/api/employer/getOrgDetails/${user._id}`);

  //         setOrganizationDetails(data.data.organizationDetails);
  //     }

  //     if (user) {
  //         getOrgDetails();
  //     }
  // }, [user])

  // useEffect(() => {
  //     async function getOrgDetails() {
  //         try {
  //             const { data } = await axios.get(`/api/employer/getOrgDetails/${user._id}`);
  //             const details = data?.data?.organizationDetails || {
  //                 name: "",
  //                 description: "",
  //                 link: { url: "", linkType: "" }
  //             };

  //             setOrganizationDetails(details);

  //             // Validation checks for first visit
  //             if (!details?.name) {
  //                 setResponseData({ color: "red", message: "Please add Organization details" });
  //             } else if (!details?.description) {
  //                 setResponseData({ color: "red", message: "Please enter Organization description" });
  //             } else if (!details?.link?.url) {
  //                 setResponseData({ color: "red", message: "Please enter an Organization website URL" });
  //             } else {
  //                 setResponseData({ color: "green", message: "Organization details loaded successfully" });
  //             }
  //         } catch (error) {
  //             console.error("Error fetching organization details:", error);
  //             setResponseData({ color: "red", message: "Unable to load organization details." });
  //         }
  //     }

  //     if (user?._id) {
  //         getOrgDetails();
  //     }
  // }, [user]);

  useEffect(() => {
    async function getOrgDetails() {
      try {
        const { data } = await axios.get(
          `/api/employer/getOrgDetails/${user._id}`
        );
        const details = data?.data?.organizationDetails || {
          name: "",
          description: "",
          link: { url: "", linkType: "" },
        };

        setOrganizationDetails(details);
        setHasFetchedData(true);

        // Set initial message only if data is empty (first time user)
        if (!details.name && !details.description && !details.link.url) {
          setInitialMessage({
            color: "red",
            message: "Please complete your organization details to continue",
          });
        } else if (!details.name) {
          setInitialMessage({
            color: "red",
            message: "Organization name is required",
          });
        } else if (!details.description) {
          setInitialMessage({
            color: "red",
            message: "Organization description is required",
          });
        } else if (!details.link.url) {
          setInitialMessage({
            color: "red",
            message: "Website URL is required for verification",
          });
        } else {
          setInitialMessage({
            color: "green",
            message: "Your organization details are complete",
          });
        }
      } catch (error) {
        console.error("Error fetching organization details:", error);
        setInitialMessage({
          color: "red",
          message: "Unable to load organization details. Please try again.",
        });
      }
    }

    if (user?._id) {
      getOrgDetails();
    }
  }, [user]);

  return (
    <div className="organization-details">
      <form onSubmit={submit} className="organization-form">
        <h3 className="title">Organization Details</h3>
        <div className="form-box">
          {/* <div className="input-box">
                        <label htmlFor="organisationName">Organization Name</label>
                        <input type="text" onChange={handleInputChange} value={organizationDetails.name} name='name' />
                    </div>
                    <div className="input-box">
                        <label htmlFor="description">Description</label>
                        <textarea onChange={handleInputChange} value={organizationDetails.description} name="description"></textarea>
                    </div> */}
          <div className="input-box">
            <label htmlFor="organisationName">Organization Name *</label>
            <input
              type="text"
              onChange={handleInputChange}
              value={organizationDetails.name}
              name="name"
              placeholder="Enter your organization name"
              required
            />
          </div>
          <div className="input-box">
            <label htmlFor="description">Description *</label>
            <textarea
              onChange={handleInputChange}
              value={organizationDetails.description}
              name="description"
              placeholder="Describe your organization"
              required
            ></textarea>
          </div>
        </div>
        <h3 className="title">Verification</h3>
        <div className="check-input-box">
          <div className="input-box">
            <input
              type="radio"
              onChange={handleRadioChange}
              name="linkType"
              id="page"
              value="page"
            />
            <label htmlFor="page">Website or Media Page</label>
          </div>
          {/* {organizationDetails.link.linkType === "page" && <div className="input-box">
                        <input type="text" name='url' value={organizationDetails.link.url} onChange={handleRadioChange} />
                    </div>} */}
          {organizationDetails.link.linkType === "page" && (
            <div className="input-box">
              <input
                type="text"
                name="url"
                value={organizationDetails.link.url}
                onChange={handleRadioChange}
                placeholder="Enter website URL *"
                required
              />
            </div>
          )}
          <div className="input-box">
            <input
              type="radio"
              onChange={handleRadioChange}
              name="linkType"
              id="website"
              value="website"
            />
            <label htmlFor="website">Official Company Website</label>
          </div>
          {organizationDetails.link.linkType === "website" && (
            <div className="input-box">
              <input
                type="text"
                name="url"
                value={organizationDetails.link.url}
                onChange={handleRadioChange}
              />
            </div>
          )}
        </div>
        {/* {responseData.message && <div style={{ marginTop: "2rem", textAlign: "center", fontSize: "1.4rem", fontWeight: "500", color: responseData.color }}> {responseData.message} </div>} */}
        {/* Show initial message if it exists */}
        {initialMessage.message && (
          <div
            style={{
              marginBottom: "2rem",
              textAlign: "center",
              fontSize: "1.4rem",
              fontWeight: "500",
              color: initialMessage.color,
            }}
          >
            {initialMessage.message}
          </div>
        )}
        // ... rest of the form fields ...
        {/* Show submit message if it exists */}
        {submitMessage.message && (
          <div
            style={{
              marginTop: "2rem",
              textAlign: "center",
              fontSize: "1.4rem",
              fontWeight: "500",
              color: submitMessage.color,
            }}
          >
            {submitMessage.message}
          </div>
        )}
        <div style={{ display: "flex", margin: "2rem" }}>
          <button
            type="submit"
            className="btn btn-primary"
            style={{
              marginLeft: "auto",
              marginRight: "auto",
            }}
          >
            {loading ? <Spinner /> : "Submit"}
          </button>
        </div>
      </form>
    </div>
  );
}

export default OrganizationDetails;
